/** User-facing errors: clear Portuguese text, never stack traces. */
export class AppError extends Error {
  constructor(
    message: string,
    readonly kind: 'permission' | 'conflict' | 'validation' | 'not_found' | 'network' | 'auth' | 'unknown' = 'unknown',
  ) {
    super(message)
    this.name = 'AppError'
  }
}

export function errorMessage(error: unknown): string {
  if (error instanceof AppError) return error.message
  const msg = (error as { message?: string })?.message ?? ''
  if (/Failed to fetch|NetworkError|Load failed/.test(msg)) return 'Sem ligação ao servidor. Verifique a sua ligação e tente novamente.'
  if (/[áàâãçéêíóôõú]|não|sem permissão/i.test(msg)) return msg
  return 'Ocorreu um erro inesperado. Tente novamente.'
}
